module.exports = __webpack_public_path__ + "img/photo_2021-12-22_16-49-16.2fe2c271.png";